/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateVoucherDto } from '../../models/create-voucher-dto';
import { VoucherDto } from '../../models/voucher-dto';

export interface AdminVoucherControllerCreate$Params {
      body: CreateVoucherDto
}

export function adminVoucherControllerCreate(http: HttpClient, rootUrl: string, params: AdminVoucherControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<VoucherDto>> {
  const rb = new RequestBuilder(rootUrl, adminVoucherControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VoucherDto>;
    })
  );
}

adminVoucherControllerCreate.PATH = '/api/voucher/admin';
